import { render } from "./SubmitWithLoaderComponent.vue?vue&type=template&id=7763dac8&scoped=true"
import script from "./SubmitWithLoaderComponent.vue?vue&type=script&lang=js"
export * from "./SubmitWithLoaderComponent.vue?vue&type=script&lang=js"

import "./SubmitWithLoaderComponent.vue?vue&type=style&index=0&id=7763dac8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7763dac8"]])

export default __exports__